import { render, staticRenderFns } from "./ProfileImageAvatar.vue?vue&type=template&id=4cc6e4a6&"
import script from "./ProfileImageAvatar.vue?vue&type=script&lang=js&"
export * from "./ProfileImageAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports